import styled, { keyframes } from "styled-components";

const skeletonAnimation = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: .5;
  }
`;

export const ResultsSkeletonContainer = styled.div`
  margin-top: 60px;

  @media (min-width: 650px) {
    margin-top: 40px;
    margin-left: ${({ horizontal, areThereFilters }) =>
      horizontal || areThereFilters ? 0 : "20px"};
  }
`;

export const ItemSkeletonContainer = styled.div`
  --skeleton-main-max-height: unset;
  --skeleton-main-display: grid;
  --skeleton-main-width: 1320px;

  --skeleton-node-gap: 5px;
  --skeleton-node-repeat: 2;
  --skeleton-node-width: 45vw;
  --skeleton-node-height: 384px;
  --skeleton-node-color: #efefef;

  @media (min-width: 650px) {
    --skeleton-node-gap: 30px;
    --skeleton-node-repeat: 4;
    --skeleton-node-width: ${({ horizontal }) =>
      horizontal ? "250px" : "200px"};
    --skeleton-node-height: 408px;
    --skeleton-node-color: #efefef;
  }

  .bnly-skeleton-node-body {
    box-sizing: content-box;
    width: 100%;
    padding: 0;

    display: var(--skeleton-main-display);
    max-width: var(--skeleton-main-width);
    grid-template-columns: repeat(
      var(--skeleton-node-repeat),
      minmax(var(--skeleton-node-width), 1fr)
    );
    gap: var(--skeleton-node-gap);
  }

  .bnly-skeleton-node {
    width: 100%;
    height: var(--skeleton-node-height);
    background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat,
      no-repeat, no-repeat, no-repeat, no-repeat, no-repeat, no-repeat,
      no-repeat;
    background-image: radial-gradient(
        circle calc(var(--skeleton-node-width) * 0.05) at
          calc(var(--skeleton-node-width) * 0.05)
          calc(var(--skeleton-node-width) * 0.05),
        var(--skeleton-node-color) calc(var(--skeleton-node-width) * 0.05),
        transparent calc(var(--skeleton-node-width) * 0.05),
        transparent 100%
      ),
      radial-gradient(
        circle calc(var(--skeleton-node-width) * 0.05) at
          calc(var(--skeleton-node-width) * 0.05)
          calc(var(--skeleton-node-width) * 0.05),
        var(--skeleton-node-color) calc(var(--skeleton-node-width) * 0.05),
        transparent calc(var(--skeleton-node-width) * 0.05),
        transparent 100%
      ),
      radial-gradient(
        circle calc(var(--skeleton-node-width) * 0.05) at
          calc(var(--skeleton-node-width) * 0.05)
          calc(var(--skeleton-node-width) * 0.05),
        var(--skeleton-node-color) calc(var(--skeleton-node-width) * 0.05),
        transparent calc(var(--skeleton-node-width) * 0.05),
        transparent 100%
      ),
      radial-gradient(
        circle calc(var(--skeleton-node-width) * 0.05) at
          calc(var(--skeleton-node-width) * 0.05)
          calc(var(--skeleton-node-width) * 0.05),
        var(--skeleton-node-color) calc(var(--skeleton-node-width) * 0.05),
        transparent calc(var(--skeleton-node-width) * 0.05),
        transparent 100%
      ),
      radial-gradient(
        circle calc(var(--skeleton-node-width) * 0.05) at
          calc(var(--skeleton-node-width) * 0.05)
          calc(var(--skeleton-node-width) * 0.05),
        var(--skeleton-node-color) calc(var(--skeleton-node-width) * 0.05),
        transparent calc(var(--skeleton-node-width) * 0.05),
        transparent 100%
      ),
      linear-gradient(var(--skeleton-node-color) 7px, transparent 0),
      linear-gradient(var(--skeleton-node-color) 7px, transparent 0),
      linear-gradient(var(--skeleton-node-color) 20px, transparent 0),
      linear-gradient(var(--skeleton-node-color) 10px, transparent 0),
      linear-gradient(var(--skeleton-node-color) 10px, transparent 0),
      linear-gradient(var(--skeleton-node-color) 10px, transparent 0),
      linear-gradient(
        var(--skeleton-node-color) var(--skeleton-node-width),
        transparent 0
      );

    background-size: calc(var(--skeleton-node-width) * 0.1)
        var(--skeleton-node-height),
      calc(var(--skeleton-node-width) * 0.1) var(--skeleton-node-height),
      calc(var(--skeleton-node-width) * 0.1) var(--skeleton-node-height),
      calc(var(--skeleton-node-width) * 0.1) var(--skeleton-node-height),
      calc(var(--skeleton-node-width) * 0.1) var(--skeleton-node-height),
      calc(var(--skeleton-node-width) * 0.8) var(--skeleton-node-height),
      calc(var(--skeleton-node-width) * 0.8) var(--skeleton-node-height),
      calc(var(--skeleton-node-width) * 0.5) var(--skeleton-node-height),
      calc(var(--skeleton-node-width) * 0.6) var(--skeleton-node-height),
      calc(var(--skeleton-node-width) * 0.8) var(--skeleton-node-height),
      calc(var(--skeleton-node-width) * 1) var(--skeleton-node-height),
      var(--skeleton-node-width) var(--skeleton-node-height);

    background-position: left calc(var(--skeleton-node-width) * 0.4 + 12px) top
        calc(var(--skeleton-node-width) + 120px),
      left calc(var(--skeleton-node-width) * 0.3 + 9px) top
        calc(var(--skeleton-node-width) + 120px),
      left calc(var(--skeleton-node-width) * 0.2 + 6px) top
        calc(var(--skeleton-node-width) + 120px),
      left calc(var(--skeleton-node-width) * 0.1 + 3px) top
        calc(var(--skeleton-node-width) + 120px),
      left calc(var(--skeleton-node-width) * 0) top
        calc(var(--skeleton-node-width) + 120px),
      left calc(var(--skeleton-node-width) * 0) top
        calc(var(--skeleton-node-width) + 100px),
      left calc(var(--skeleton-node-width) * 0) top
        calc(var(--skeleton-node-width) + 92px),
      left calc(var(--skeleton-node-width) * 0) top
        calc(var(--skeleton-node-width) + 70px),
      left calc(var(--skeleton-node-width) * 0) top
        calc(var(--skeleton-node-width) + 33px),
      left calc(var(--skeleton-node-width) * 0) top
        calc(var(--skeleton-node-width) + 22px),
      left calc(var(--skeleton-node-width) * 0) top
        calc(var(--skeleton-node-width) + 10px),
      left 0 top 0;

    animation: ${skeletonAnimation} 1.5s infinite ease-in-out;
  }
`;

export const FiltersSkeletonContainer = styled.div`
  --skeleton-filter-name-height: 25px;
  --skeleton-filter-option-height: 15px;

  .bnly-filter-name-skeleton {
    width: 100%;
    height: var(--skeleton-filter-name-height);
    margin: 40px 0 10px;

    background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
    background-size: 200% 100%;
    animation: ${skeletonAnimation} 1.5s infinite ease-in-out;
  }
`;

export const FilterOptionSkeleton = styled.div`
  width: ${(props) => props.width};
  height: var(--skeleton-filter-option-height);

  background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  margin: 5px 0;
  animation: ${skeletonAnimation} 1.5s infinite ease-in-out;
`;

export const HorizontalFilterSkeleton = styled.div`
  width: 90%;
  height: 50px;

  background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: ${skeletonAnimation} 1.5s infinite ease-in-out;
`;

export const TitleSkeletonContainer = styled.div`
  --skeleton-title-background: linear-gradient(
    90deg,
    #e0e0e0 25%,
    #f0f0f0 50%,
    #e0e0e0 75%
  );
  --skeleton-title-height: 40px;
  --skeleton-title-width: 50%;
  --skeleton-title-mobile-height: 55px;
  --skeleton-title-mobile-width: 85%;

  --skeleton-title-paragraph-height: 20px;
  --skeleton-title-paragraph-width: 25%;
  --skeleton-title-paragraph-mobile-height: 30px;
  --skeleton-title-paragraph-mobile-width: 60%;

  .bnly-title-skeleton {
    width: var(--skeleton-title-mobile-width);
    height: var(--skeleton-title-mobile-height);
    background: var(--skeleton-title-background);
    background-size: 200% 100%;
    margin: 40px auto 10px;
    animation: ${skeletonAnimation} 1.5s infinite ease-in-out;

    @media (min-width: 650px) {
      margin: 40px 0 10px;
      width: var(--skeleton-title-width);
      height: var(--skeleton-title-height);
    }
  }

  .bnly-title-paragraph-skeleton {
    width: var(--skeleton-title-paragraph-mobile-width);
    height: var(--skeleton-title-paragraph-mobile-height);
    margin: 0 auto 20px;
    background: var(--skeleton-title-background);
    background-size: 200% 100%;
    animation: ${skeletonAnimation} 1.5s infinite ease-in-out;

    @media (min-width: 650px) {
      width: var(--skeleton-title-paragraph-width);
      height: var(--skeleton-title-paragraph-height);
      margin: 0 0 20px;
    }
  }
`;
